import * as types from './actionTypes';
import { App } from '../../../../../data/terra/App';
import { AppVersion } from '../../../../../data/terra/AppVersion';
import { ActionDelegate } from 'containers/Base/ActionDelegate';
import { addAppDelegate } from './actions/AddApp';
import { addAppVersionDelegate } from './actions/AddAppVersion';
import { fetchAppsDelegate } from './actions/FetchApps';
import { selectAppDelegate } from './actions/SelectApp';
import { selectAppVersionDelegate } from './actions/SelectAppVersion';
import { Environment } from 'data/terra/Environment';
import { selectEnvDelegate } from './actions/SelectEnv';
import { AppConfig } from 'data/terra/AppConfig';

export interface AppSelectorState {
  apps: App[];
  selectedApp?: App;
  appVersions: AppVersion[];
  selectedAppVersion?: AppVersion;
  selectedEnv?: Environment;
  appConfigs: AppConfig[];
}

const initialState: AppSelectorState = {
  apps: [],
  appVersions: [],
  appConfigs: [],
};

const delegates: {
  [key: string]: ActionDelegate<any, AppSelectorState>;
} = {
  ...addAppDelegate,
  ...addAppVersionDelegate,
  ...fetchAppsDelegate,
  ...selectAppDelegate,
  ...selectAppVersionDelegate,
  ...selectEnvDelegate,
};

export default function reduce(
  state: AppSelectorState = initialState,
  action: types.AppSelectorAction
): AppSelectorState {
  const delegate = delegates[action.type];
  if (delegate) {
    return delegate(state, action);
  } else {
    return state;
  }
}
